import React, { useState } from "react";
import { MapPinHouse, Phone, Youtube } from "lucide-react";
import { useNavigate } from "react-router-dom";

const MainLayout = ({ children }) => {
  const navigate = useNavigate();
  const [showVideoPopup, setShowVideoPopup] = useState(false);
  // const youtubeVideoId = "P2qkvFMx8LU"; // Extracted from your URL

  // const handlePhoneClick = () => {
  //   // window.location.href = "tel:800-8293(800 UCWF)";
  //   navigate("/contact-us#contact");
  // };
  const handlePhoneClick = () => {
    navigate("/contact-us#contact", { replace: true });
    // Force scroll after navigation
    setTimeout(() => {
      const element = document.getElementById('contact');
      if (element) element.scrollIntoView({ behavior: 'smooth' });
    }, 100);
  };

  const handleLocationClick = () => {
    navigate("/contact-us#location", { replace: true });
    // Force scroll after navigation
    setTimeout(() => {
      const element = document.getElementById('location');
      if (element) element.scrollIntoView({ behavior: 'smooth' });
    }, 100);
  };

  // const handleLocationClick = () => {
  //   navigate("/contact-us#location");
  // };

  const toggleVideoPopup = () => {
    setShowVideoPopup(!showVideoPopup);
  };

  return (
    <>
      <div className="vertical-contact-info">
        <div className="vertical-line"></div>
        <div className="contact-item" onClick={handlePhoneClick}>
          <span className="contact-icon">
            <Phone />
          </span>
        </div>
        <div className="contact-item" onClick={handleLocationClick}>
          <span className="contact-icon">
            <MapPinHouse />
          </span>
        </div>
        <div className="contact-item" onClick={toggleVideoPopup}>
          <span className="contact-icon">
            <Youtube />
          </span>
        </div>
        <div className="vertical-line"></div>
      </div>

      {/* Video Popup Modal */}
      {showVideoPopup && (
        <div className="video-popup-overlay" onClick={toggleVideoPopup}>
          <div
            className="video-popup-content"
            onClick={(e) => e.stopPropagation()}
          >
            <button className="close-button" onClick={toggleVideoPopup}>
              &times;
            </button>
            <div className="video-container">
              {/* <iframe
                width="560"
                height="315"
                src={`https://www.dropbox.com/scl/fi/icx51qz11m0qdu84k6yyg/UCWF-1.mp4?rlkey=3yib52pn9jg5fa6t7egz6va8a&e=1&raw=1`}
                title=" video player"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              ></iframe> */}
              <video controls>
                <source
                  src="https://cdn.safcodes.com/ucwf/team.mp4"
                  type="video/mp4"
                />
                Your browser does not support the video tag.
              </video>
            </div>
          </div>
        </div>
      )}

      {children}

      <style>
        {`
          .video-popup-overlay {
            position: fixed;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            background-color: rgba(0, 0, 0, 0.8);
            display: flex;
            justify-content: center;
            align-items: center;
            z-index: 1000;
          }

          .video-popup-content {
            position: relative;
            background-color: transparent;
            max-width: 800px;
            width: 90%;
            margin: 0 auto;
          }

          .close-button {
            position: absolute;
            top: -40px;
            right: 0;
            background: none;
            border: none;
            color: white;
            font-size: 30px;
            cursor: pointer;
            z-index: 1100;
          }

          .video-container {
            position: relative;
            padding-bottom: 56.25%; /* 16:9 aspect ratio */
            height: 0;
            overflow: hidden;
            width: 100%;
          }

          .video-container video {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            border: none;
          }

          @media (max-width: 768px) {
            .video-popup-content {
              width: 95%;
            }
          }
        `}
      </style>
    </>
  );
};

export default MainLayout;
